module.exports = __webpack_public_path__ + "static/src/content/images/processed/800/thurston_promo_custom.97d2002.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/800/thurston_promo_custom.jpg
// module id = fytF
// module chunks = 1